import React from 'react';
import { Link } from 'react-router-dom';
import { Code2 } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <Code2 size={16} />
              <span>token-kit</span>
            </div>
            <p>The developer platform for adding user-funded AI features to any application.</p>
            <a href="mailto:contact@codetunezstudios.com" className="footer-contact">contact@codetunezstudios.com</a>
          </div>
          <div className="footer-col">
            <h4>Product</h4>
            <ul>
              <li><a href="/#how-it-works">How It Works</a></li>
              <li><a href="/#pricing">Pricing</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Developers</h4>
            <ul>
              <li><a href="/#docs">Quick Start</a></li>
              <li><Link to="/sdk">SDK Docs</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} token-kit. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
